import {Checkbox, FormControlLabel, styled} from "@mui/material"
import React from "react"

const StyledCheckbox = styled(Checkbox)(({theme}) => ({
    padding: 0,
    margin: "0 8px 0 0",
}))

const StyledFormControlLabel = styled(FormControlLabel)(({theme}) => ({
    margin: 0,
}))

const CheckboxWidget = ({widget, value, onValueChange}) => {
    const handleChange = (event) => {
        event.stopPropagation()
        const nextValue = event.target.checked
        onValueChange(nextValue)
    }

    return (
        <StyledFormControlLabel
            onClick={(event) => event.stopPropagation()}
            control={
                <StyledCheckbox
                    checked={Boolean(value)}
                    value={Boolean(value)}
                    onChange={handleChange}
                />
            }
            label={widget.text}
            slotProps={{
                typography: {
                    variant: "label",
                },
            }}
        />
    )
}

export default CheckboxWidget
